import { render, staticRenderFns } from "./WhatsNewIcon.vue?vue&type=template&id=7515e511&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7515e511')) {
      api.createRecord('7515e511', component.options)
    } else {
      api.reload('7515e511', component.options)
    }
    module.hot.accept("./WhatsNewIcon.vue?vue&type=template&id=7515e511&", function () {
      api.rerender('7515e511', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/assets/icons/WhatsNewIcon.vue"
export default component.exports